import { useQueryClient } from '@tanstack/react-query';
import { memo, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { FaqManagementSection } from './FaqManagementSection';
import { KnowledgeBaseSection } from './KnowledgeBaseSection';

interface FaqTabProps {
  openNextTab: () => void;
  mentorId: string;
  isReadyStatus: boolean;
  localTwinIsReady: boolean;
}

export interface Faq {
  question: string;
  answer: string;
  id: string;
  isNew?: boolean;
}

const FaqTab: React.FC<FaqTabProps> = memo(
  ({ openNextTab, mentorId, isReadyStatus, localTwinIsReady }) => {
    const navigate = useNavigate();

    const queryClient = useQueryClient();

    const goToFaq = () => {
      navigate('/twin/knowledge/faq');
    };

    useEffect(() => {
      if (localTwinIsReady) {
        void queryClient.invalidateQueries({
          queryKey: ['getTwinPersonaById'],
        });
      }
    }, [localTwinIsReady]);

    return (
      <Routes>
        <Route
          path="/files"
          element={
            <KnowledgeBaseSection
              goNext={goToFaq}
              mentorId={mentorId}
              isReadyStatus={isReadyStatus}
            />
          }
        />
        <Route
          path="/faq"
          element={
            <FaqManagementSection
              openNextTab={openNextTab}
              isReadyStatus={isReadyStatus}
              mentorId={mentorId}
            />
          }
        />
      </Routes>
    );
  },
);

export { FaqTab };
